module.exports = "/fonts/fa-solid-900.svg?ec763292e583294612f124c0b0def500";